// @ts-nocheck
import { createPortal } from 'react-dom';
import Card from '../Card/card';

import cx from 'classnames';

import styles from './modal.module.scss';
import { IconEnum } from '../../icon/icon.enum';
import { Icon } from '../../icon/icon';

export interface ModalProps {
  className?: string;
  isOpened?: boolean;
  hasCloseBtn?: boolean;
  onCloseModal?: Function;
  children: React.ReactElement;
  disableExitOnOverlay?: boolean;
}

export const Modal = (props: ModalProps) => {
  const {
    className = '',
    isOpened = false,
    onCloseModal = () => false,
    children,
    hasCloseBtn,
    disableExitOnOverlay = false,
  } = props;

  const portalNode =
    document.getElementById('modal-root') || document.createElement('div');

  if (!portalNode || !isOpened) {
    return <></>;
  }

  return createPortal(
    <div
      className={styles['Modal-overlay']}
      onClick={() => {
        !disableExitOnOverlay && onCloseModal && onCloseModal();
      }}
    >
      <Card
        className={cx(styles['Modal'], className)}
        onClick={(e) => e.stopPropagation()}
      >
        <>
          {hasCloseBtn && (
            <button
              className={cx(styles['Modal-close'])}
              onClick={() => {
                onCloseModal && onCloseModal();
              }}
            >
              <Icon name={IconEnum.CLOSE} />
            </button>
          )}
          {children}
        </>
      </Card>
    </div>,
    portalNode
  );
};

export default Modal;
